import {
  CUSTOMIZATION_REQUEST_ASYNC,
  LANGUAGE_CHANGE,
  UPDATE_CUSTOMIZATION_REQUEST,
} from './constants'

const getCustomizationSettings = () => ({
  type: CUSTOMIZATION_REQUEST_ASYNC.INITIATE,
})
export const getCustomizationSettingsSuccess = (data) => ({
  type: CUSTOMIZATION_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getCustomizationSettingsError = (error) => ({
  type: CUSTOMIZATION_REQUEST_ASYNC.ERROR,
  error,
})
const getCustomizationSettingsCancel = () => ({
  type: CUSTOMIZATION_REQUEST_ASYNC.CANCEL,
})

const updateCustomizationSettings = (data) => ({
  type: UPDATE_CUSTOMIZATION_REQUEST.INITIATE,
  payload: { data },
})
export const updateCustomizationSettingsSuccess = () => ({
  type: UPDATE_CUSTOMIZATION_REQUEST.SUCCESS,
})
export const updateCustomizationSettingsError = (error) => ({
  type: UPDATE_CUSTOMIZATION_REQUEST.ERROR,
  error,
})

const languageChange = (language) => ({
  type: LANGUAGE_CHANGE,
  payload: { language },
})

export default {
  // to props
  getCustomizationSettings,
  getCustomizationSettingsCancel,
  updateCustomizationSettings,
  languageChange,
}
